import React, {useEffect, useState} from 'react';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

// custom components
import { Text, Button } from '../atoms';

// styles
import { Colors } from '../../styles/index';

import { signup as Signup, login } from '../../services/firebase';

// redux
import { useSelector, useDispatch} from 'react-redux';
import { LoginUser, selectUserStatus, selectUserError, reset } from '../../redux/slices/user';

const Login = (props) => {

    const dispatch = useDispatch()
    const userStatus = useSelector(selectUserStatus);
    const errorFlag = useSelector(selectUserError);

    const signup = false;
    
    //#region states and error validators
    const [firstRender, setFirstRender] = useState(true)
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [emailError, setEmailError] = useState('')
    const [passwordError, setPasswordError] = useState('')

    function isValidEmailAddress(address) {
        return !! address.match(/.+@.+/);
    }

    useEffect(() => {
        if(isValidEmailAddress(email) == false && firstRender == false){
            setEmailError('Valid email required ');
        }
        if(isValidEmailAddress(email) == true && firstRender == false){
            setEmailError('');
        }
    }, [email]);

    useEffect(() => {
        if(password.length > 0){
            setPasswordError('')
        }
    }, [password]);

    useEffect(() => {
        setFirstRender(false)
    }, [firstRender]);
    //#endregion

    // function to handle submission
    const onClick = () => {
        if(password.length == 0){
            setPasswordError('Enter your password')
        }
        if(email.length == 0){
            setEmailError('Enter your email')
            return;
        }
        if(isValidEmailAddress == false){
            setEmailError('Valid email required')
            return;
        }

        // signup
        if(signup){
            Signup({
                'email':email,
                'password':password
            })
        }
        // login
        else {
            dispatch(LoginUser({
                'email':email,
                'password':password
            }))
        }
    }

    return (
        <Row style={{
            width:500,
        }}>
            <Col>
                <Container className='mt-3' style={{
                    borderRadius:10,
                    padding:32,
                    paddingBottom:50,
                    boxShadow:'0px 7px 29px 0px; rgba(100, 100, 111, 0.2)'
                }}>
                    
                    {/* Text */}
                    <Text.Title>Authentication</Text.Title>
                    <Text.Subtitle>{ signup ? 'Sign up' : 'Login'}</Text.Subtitle>
                    <Text.Text>In order to access the Connect Docs we first require you to login</Text.Text>

                    {/* Form */}
                    <Form className='mt-5'>

                        {/* Email */}
                        <Form.Group className="mt-3">
                            <Row>
                                <Col>
                                    <Form.Label style={{ color:Colors.PRM_LIGHT_BLUE }}>Email</Form.Label>
                                    <Form.Control type="email" placeholder="" style={{}} value={email} defaultValue={email} onChange={(e) => { setEmail(e.target.value)}} />
                                    {
                                        emailError.length > 0 && (
                                            <p style={{color:Colors.TEXT_COLOR, marginLeft:6}} className="text-danger">{emailError}</p>
                                        )
                                    }
                                </Col>
                            </Row>
                        </Form.Group>

                        {/* Password */}
                        <Form.Group className={ emailError.length > 0 ? 'mt-2' : "mt-5"}>
                            <Row>
                                <Col>
                                    <Form.Label style={{ color:Colors.PRM_LIGHT_BLUE }}>Password</Form.Label>
                                    <Form.Control type="password" placeholder="" style={{}} value={password} defaultValue={password} onChange={(e) => { setPassword(e.target.value)}} />
                                    {
                                        passwordError.length > 0 && (
                                            <p style={{color:Colors.TEXT_COLOR, marginLeft:6}} className="text-danger">{passwordError}</p>
                                        )
                                    }
                                </Col>
                            </Row>
                        </Form.Group>

                        {/* Button */}
                        <Form.Group className={ passwordError.length > 0 ? 'mt-2' : "mt-5"}>
                            <Row style={{paddingLeft:50, paddingRight:50}}>
                                <Button
                                    status={userStatus}
                                    onClick={onClick}
                                >{signup ? 'Sign up' : 'Log in'}</Button>
                            </Row>
                        </Form.Group>
                        {
                            errorFlag && errorFlag.length > 0 && (
                                <p style={{color:'red', marginLeft:6}} className="text-danger">{errorFlag}</p>
                            )
                        }

                    </Form>

                </Container>
            </Col>
        </Row>
    );
};

export default Login;